"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizationModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const permissions_guard_1 = require("../../common/guards/permissions.guard");
const roles_guard_1 = require("../../common/guards/roles.guard");
const authorization_service_1 = require("./authorization.service");
const role_entity_1 = require("./role.entity");
const roles_controller_1 = require("./roles.controller");
let AuthorizationModule = class AuthorizationModule {
};
exports.AuthorizationModule = AuthorizationModule;
exports.AuthorizationModule = AuthorizationModule = tslib_1.__decorate([
    (0, common_1.Global)(),
    (0, common_1.Module)({
        imports: [typeorm_1.TypeOrmModule.forFeature([role_entity_1.Role])],
        controllers: [roles_controller_1.RolesController],
        providers: [authorization_service_1.AuthorizationService, permissions_guard_1.PermissionsGuard, roles_guard_1.RolesGuard],
        exports: [authorization_service_1.AuthorizationService, permissions_guard_1.PermissionsGuard, roles_guard_1.RolesGuard],
    })
], AuthorizationModule);
